<template>
  <base-dialog class="gray-publish-dialog" :visible.sync="visible">
    <template #header>灰度发布</template>
    <div class="row">
      <span>应用</span>
      <normal-select
        :selectList="options"
        :selectedItem.sync="selectedAppIds"
        multiple
        filterable
      ></normal-select>
    </div>
    <template #footer>
      <base-button type="primary" @click="submit">确定</base-button>
      <base-button @click="visible = false">取消</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"
import NormalSelect from "@/components/UIComponents/NormalSelect.vue"
import BaseButton from "@/components/UIComponents/Button.vue"
import { getAppListByTemplate, updateAppByTemplate } from "@/api/userCenter/app"
import { loadingService } from "@/utils/ui"

export default {
  name: "gray-publish-dialog",
  components: { BaseDialog, NormalSelect, BaseButton },
  data() {
    return {
      visible: false,
      templateId: null,
      apps: [],
      selectedAppIds: []
    }
  },
  computed: {
    options() {
      return (this.apps || []).map(app => ({
        label: `${app.name} (${app.companyName})`,
        value: app.id
      }))
    }
  },
  methods: {
    open(templateId) {
      this.templateId = templateId
      this.apps = []
      this.selectedAppIds = []
      getAppListByTemplate(templateId).then(apps => (this.apps = apps))
      this.visible = true
    },
    submit() {
      if (this._.isEmpty(this.selectedAppIds)) {
        this.$message.error("请选择应用")
      }
      const loading = loadingService()
      updateAppByTemplate(this.templateId, this.selectedAppIds).then(res => {
        this.$message.success("操作成功")
        loading.close()
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.gray-publish-dialog {
  .row {
    display: flex;
    align-items: center;
    span {
      flex: 0 0 auto;
      margin-right: 10px;
    }
    .normal-select {
      flex: 1;
    }
  }
}
</style>
